import {
    Component,
    OnInit,
    ViewChild,
    TemplateRef,
    AfterViewInit,
    NgZone,
    OnDestroy
} from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { debounceTime } from 'rxjs/operators';
import { Messages } from '../constants/messages';
import { environment } from 'src/environments/environment';
import { v4 as uuidv4 } from 'uuid';

declare var google: any;

interface LocationInterface {
    _id: string;
    area: string;
    landmark: string;
    pincode: string;
    city: string;
    state: string;
    name: string;
    desc: string;
    geo_point: {
        type: string;
        coordinates: [number, number];
    };
    shipper: string;
    geofences: { id: string; coordinates: any[] }[]; // Array of Geofences
    type: string;
    severity: number;
    is_deleted: boolean;
    token: string;
    created_at: string;
    updated_at: string;
    __v: number;
    geo_fence: {
        type: string;
        coordinates: any[];
    };
}

@Component({
    selector: 'app-no-zone',
    templateUrl: './no-zone.html',
    styleUrls: ['./no-zone.scss'],
})
export class NoZoneComponent implements OnInit, AfterViewInit, OnDestroy {
    Math: any = Math;

    map: any;
    addlocationMap: any;
    geofenceMap: any;

    drawingManager: any;
    geofenceCoords: any[] = [];
    messages = new Messages();
    isDrawingMode: boolean = false;
    isNewGeofence: boolean = true;
    selectedGeofenceId: string | null = null;
    highlightedGeofence: string | null = null;
    allPolygons: any[] = []; // Array of ALL Polygon instances

    selectedRestrictedList = 'master';
    states: { name: string; code: string }[] = [
        { name: 'California', code: 'CA' },
        { name: 'Texas', code: 'TX' },
        { name: 'Florida', code: 'FL' },
        { name: 'New York', code: 'NY' },
        { name: 'Illinois', code: 'IL' },
    ];
    typeForNewLocation: string[] = [
        'Hotel',
        'Dhaba',
        'Resting Zone',
        'Fuel Station',
        'Forest',
        'Road Side',
        'Others',
    ];
    selectedStateCode: string = '';
    searchTerm: string = '';
    locations: LocationInterface[] = [];
    currentPage: number = 1;
    itemsPerPageOptions: number[] = [5, 10, 20, 50];
    itemsPerPage: number = 5;
    type;
    addRestrictedLocationDialogRef: MatDialogRef<any>;
    geofencepopupDialogRef: MatDialogRef<any>;
    deleteConfirmationDialogRef: MatDialogRef<any>; // Add this
    showLoader = false;
    newLocation: any = {};
    selectedLocation: any = null;
    areaSuggestions: any[] = [];
    private searchTerm$ = new Subject<string>();
    marker: any;
    autocompleteService: any;
    selectedType: string = '';
    totalCount: number = 0;
    selectedLocationGeofence: any;
    geofenceCoordsTosend: any[] = [];
    locationToDelete: any = null; // Store the location to delete
    manualSelectionMode = false; // New flag

    @ViewChild('addGeofenceGates', { static: true })
    addGeofenceGates: TemplateRef<any>;
    @ViewChild('addRestrictedLocation', { static: true })
    addRestrictedLocation: TemplateRef<any>;
    @ViewChild('pathMap', { static: false }) mapElement: any;
    @ViewChild('geofencepopup', { static: true })
    geofencepopup: TemplateRef<any>;
    @ViewChild('deleteConfirmationDialog', { static: true })  // Add this
    deleteConfirmationDialogTemplate: TemplateRef<any>;

    private markers: any[] = [];

    //   video_URL_ADD_GEOFENCE_GATES = this.sanitizer.bypassSecurityTrustResourceUrl(
    //       environment.ADD_GEOFENCE_GATES
    //   );
    helpData = [
        {
            head: 'Help',
            data: 'View and Add your Frequent Shipment Locations. Add these as your favourites to prefill locations automatically.',
        },
    ];

    constructor(
        private dialog: MatDialog,
        private valid: ValidationService,
        private snackbar: SnackbarService,
        private http: HttpService,
        private translation: TranslateService,
        private sanitizer: DomSanitizer,
        private zone: NgZone
    ) { }

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

    ngOnInit() {
        this.autocompleteService = new google.maps.places.AutocompleteService();
        this.searchTerm$.pipe(debounceTime(300)).subscribe(searchTerm => {
            this.suggestAreas(searchTerm);
        });
        this.getInitialLocations();
    }

    ngAfterViewInit(): void {
        this.initMap();
    }

    ngOnDestroy(): void {
        if (this.geofenceMap) {
            google.maps.event.clearInstanceListeners(this.geofenceMap);
        }
        this.geofenceMap = null;
    }

    getInitialLocations(skip = 0, limit = this.itemsPerPage) {
        this.showLoader = true;
        let url = `v2/r_location/get?is_deleted=false&skip=${skip}&limit=${limit}`;
        if (this.searchTerm) {
            url += `&searchText=${this.searchTerm}`;
        }
        this.http.get(url).subscribe(
            (res: any) => {
                this.locations = res.data.locations;
                this.totalCount = res.data.count;
                this.displayLocationsOnMap();
                this.showLoader = false;
            },
            error => {
                console.error('Error fetching locations:', error);
                this.showLoader = false;
                this.snackbar.openSnackBar(
                    this.translation.instant('Error fetching locations'),
                    '',
                    'err'
                );
            }
        );
    }

    changeRestrictedList(type) {
        this.selectedRestrictedList = type;
    }

    onStateChange(event: any): void {
        console.log('Selected State Code:', this.selectedStateCode);
    }

    onSearch(): void {
        this.currentPage = 1;
        this.getInitialLocations();
    }

    onTypeChange(event: any): void {
        this.newLocation.type = this.selectedType;
    }

    onAddLocation(): void {
        this.newLocation = {};
        this.selectedLocation = null;
        this.areaSuggestions = [];
        this.manualSelectionMode = false; // Reset the flag
        this.addRestrictedLocationDialogRef = this.dialog.open(
            this.addRestrictedLocation,
            {
                width: '85vw',
                disableClose: false,
            }
        );
        this.addRestrictedLocationDialogRef.afterOpened().subscribe(() => {
            this.initAddLocationMap();
        });
    }

    closeAddRestrictedLocationDialog(): void {
        this.addRestrictedLocationDialogRef.close();
    }

    goToPreviousPage(): void {
        if (this.currentPage > 1) {
            this.currentPage--;
            this.getInitialLocations(
                (this.currentPage - 1) * this.itemsPerPage,
                this.itemsPerPage
            );
        }
    }

    goToNextPage(): void {
        const totalPages = Math.ceil(this.totalCount / this.itemsPerPage);
        if (this.currentPage < totalPages) {
            this.currentPage++;
            this.getInitialLocations(
                (this.currentPage - 1) * this.itemsPerPage,
                this.itemsPerPage
            );
        }
    }

    onItemsPerPageChange(event: any): void {
        this.itemsPerPage = parseInt(event.target.value, 10);
        this.currentPage = 1;
        this.getInitialLocations();
    }

    initMap(lat = 0, lng = 0) {
        const mapProp = {
            center: new google.maps.LatLng((lat = 20.5937), (lng = 78.9629)),
            zoom: 5,
            mapTypeControl: true,
            scaleControl: false,
            streetViewControl: false,
            zoomControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            },
        };
        this.map = new google.maps.Map(document.getElementById('pathMap'), mapProp);
        google.maps.event.addListener(this.map, 'click', function () { });
    }

    private clearMarkers(): void {
        for (let i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        this.markers = [];
    }

    displayLocationsOnMap(): void {
        if (!this.map) {
            console.warn('Map not initialized yet.');
            return;
        }
        this.clearMarkers();
        this.locations.forEach(location => {
            if (location.geo_point && location.geo_point.coordinates) {
                const longitude = location.geo_point.coordinates[0];
                const latitude = location.geo_point.coordinates[1];
                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(latitude, longitude),
                    map: this.map,
                    title: location.name,
                });
                this.markers.push(marker);
            } else {
                console.warn('Invalid coordinates for location:', location);
            }
        });
    }

    initAddLocationMap(lat = 20.5937, lng = 78.9629) {
        const mapProp = {
            center: new google.maps.LatLng(lat, lng),
            zoom: 5,
            mapTypeControl: true,
            scaleControl: false,
            streetViewControl: false,
            zoomControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            },
        };
        this.addlocationMap = new google.maps.Map(
            document.getElementById('addLocationMap'),
            mapProp
        );

        // Add a click listener to the map for manual selection
        this.addlocationMap.addListener('click', (event: any) => {
            if (this.manualSelectionMode) {
                this.placeMarkerAndGetDetails(event.latLng);
            }
        });
    }

    suggestAreas(searchTerm: string): void {
        if (!searchTerm) {
            this.areaSuggestions = [];
            return;
        }
        this.autocompleteService.getPlacePredictions(
            { input: searchTerm },
            (predictions: any, status: any) => {
                if (status !== google.maps.places.PlacesServiceStatus.OK) {
                    console.error(
                        'Autocomplete was not successful for the following reason:',
                        status
                    );
                    this.areaSuggestions = [];
                    return;
                }
                this.areaSuggestions = predictions;
            }
        );
    }

    selectArea(suggestion: any): void {
        console.log(suggestion,'suggestion');
        this.newLocation.area = suggestion.description;
        this.areaSuggestions = [];
        this.getLatLngFromPlaceId(suggestion.place_id)
            .then((latLng: any) => {
                this.placeMarkerAndGetDetails(latLng);
            })
            .catch((error: any) => {
                console.error('Error getting location from Place ID:', error);
                this.snackbar.openSnackBar('Could not retrieve location.  Enabling manual selection. Please click the map.', '', 'err');
                this.enableManualSelection();  // Enable manual selection
            });
    }

    async getLatLngFromPlaceId(placeId: string): Promise<any> {
        const geocoder = new google.maps.Geocoder();

        return new Promise((resolve, reject) => {
            geocoder.geocode({ placeId: placeId }, (results: any, status: any) => {
                if (status === 'OK' && results && results.length > 0) {
                    const location = results[0].geometry.location;
                    resolve(location);
                } else {
                    console.error('Geocode was not successful for the following reason:', status);
                    reject(status);
                }
            });
        });
    }

    placeMarkerAndGetDetails(latLng: any): void {
        if (this.marker) {
            this.marker.setMap(null);
        }
        this.marker = new google.maps.Marker({
            position: latLng,
            map: this.addlocationMap,
            title: 'Selected Location',
        });
        this.addlocationMap.setZoom(9);
        this.addlocationMap.panTo(latLng);

        this.selectedLocation = {
            lat: latLng.lat(),
            lng: latLng.lng(),
        };
        this.newLocation.coordinates = this.selectedLocation;
    }

    onSaveLocation(): void {
        if (
            !this.newLocation.name ||
            !this.newLocation.area ||
            !this.newLocation.coordinates ||
            !this.newLocation.type ||
            !this.newLocation.severity
        ) {
            this.snackbar.openSnackBar(
                this.translation.instant('All fields are required'),
                '',
                'err'
            );
            return;
        }
        const payload = {
            name: this.newLocation.name,
            area: this.newLocation.area,
            latitude: this.newLocation.coordinates.lat,
            longitude: this.newLocation.coordinates.lng,
            landmark: this.newLocation.landmark,
            pincode: this.newLocation.pincode,
            city: this.newLocation.city,
            state: this.newLocation.state,
            severity: this.newLocation.severity,
            type: this.newLocation.type,
            desc: this.newLocation.description,
        };
        this.showLoader = true;
        this.http.post('v2/r_location/add', payload).subscribe(
            (dataa: any) => {
                this.showLoader = false;
                if (dataa.statusCode === 200) {
                    this.snackbar.openSnackBar(
                        this.translation.instant('Location Added Successfully'),
                        ''
                    );
                    this.closeAddRestrictedLocationDialog();
                    this.getInitialLocations(
                        (this.currentPage - 1) * this.itemsPerPage,
                        this.itemsPerPage
                    );
                    this.getInitialLocations(
                        (this.currentPage - 1) * this.itemsPerPage,
                        this.itemsPerPage
                    ); // Refresh the list

                }
            },
            (err: any) => {
                this.showLoader = false;
                this.snackbar.openSnackBar(err.error.message, '', 'err');
            }
        );
    }

    onInputChange(searchTerm: string): void {
        this.searchTerm$.next(searchTerm);
    }

    selectAreaFromDropdown(areaDescription: string): void {
        const selectedSuggestion = this.areaSuggestions.find(
            suggestion => suggestion.description === areaDescription
        );

        if (selectedSuggestion) {
            this.selectArea(selectedSuggestion);
        }
    }

    onInputBlur() {
        if (this.newLocation.area) {
            this.suggestAreas(this.newLocation.area);
        }
    }

    onGeofence(location: any): void {
        console.log(google.maps,'goof')
        this.selectedLocationGeofence = location;

        // Clear existing geofences before loading (IMPORTANT)
        this.selectedLocationGeofence.geofences = [];

        // Conditionally convert geo_fence data from geo_fence
        if (location.geo_fence && location.geo_fence.coordinates && location.geo_fence.coordinates.length > 0) {
            const geoFence = location.geo_fence;

            // Handle both POLYGON and MULTIPOLYGON
            let polygons: any[] = [];
            if (geoFence.type === 'MULTIPOLYGON') {
                polygons = geoFence.coordinates; // Already an array of polygons
            } else if (geoFence.type === 'POLYGON') {
                polygons = geoFence.coordinates; // Wrap it in an array to treat it as a single polygon
            }

            polygons.forEach(polygon => {
                const geofenceId = uuidv4();
                this.selectedLocationGeofence.geofences.push({
                    id: geofenceId,
                    coordinates: polygon.map(coordPair => ({
                        lng: coordPair[0],
                        lat: coordPair[1]
                    }))
                });
            });
        }

        this.geofencepopupDialogRef = this.dialog.open(this.geofencepopup, {
            width: '85vw',
            disableClose: false,
            data: { location },
        });
        this.geofencepopupDialogRef.afterOpened().subscribe(() => {
            this.initGeofenceMap();
        });
    }

    initGeofenceMap(lat = 20.5937, lng = 78.9629) {
        let latitude = lat;
        let longitude = lng;

        if (this.selectedLocationGeofence.geo_point.coordinates) {
            longitude = this.selectedLocationGeofence.geo_point.coordinates[0];
            latitude = this.selectedLocationGeofence.geo_point.coordinates[1];
        }

        const mapProp = {
            center: new google.maps.LatLng(latitude, longitude),
            zoom: 12,
            mapTypeControl: true,
            scaleControl: false,
            streetViewControl: false,
            zoomControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            },
        };
        this.geofenceMap = new google.maps.Map(
            document.getElementById('geofenceMap'),
            mapProp
        );

        // add marker
        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(latitude, longitude),
            map: this.geofenceMap,
            title: 'Location',
        });

        // Drawing Manager setup
        this.drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [google.maps.drawing.OverlayType.POLYGON],
            },
            polygonOptions: {
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                strokeWeight: 2,
                clickable: true,
                editable: true,
                zIndex: 1,
            },
            map: this.geofenceMap,
        });

        // Event listener for when a new shape is completed
        google.maps.event.addListener(
            this.drawingManager,
            'overlaycomplete',
            event => {
                if (event.type === google.maps.drawing.OverlayType.POLYGON) {
                    const polygon = event.overlay;
                    polygon.type = event.type;
                    polygon.setEditable(true);
                    const geofenceId = uuidv4();
                    polygon.geofenceId = geofenceId;

                    this.allPolygons.push(polygon);
                    this.isNewGeofence = true;

                    this.getPolygonCoords(polygon, geofenceId); // Pass the polygon and ID
                }

                this.drawingManager.setDrawingMode(null);
                this.isDrawingMode = false;
            }
        );

        this.allPolygons = [];
        // Load Existing Geofences on Map
        if (
            this.selectedLocationGeofence.geofences &&
            this.selectedLocationGeofence.geofences.length > 0
        ) {
            this.selectedLocationGeofence.geofences.forEach(geofence => {
                this.loadExistingGeofence(geofence);
            });
        }
    }

    loadExistingGeofence(geofence: any) {
        console.log("Existing Geofence Data:", geofence);
        if (geofence && geofence.coordinates) {
            // Convert coordinate pairs to LatLng objects
            const path = geofence.coordinates.map(coord => {
                const lat = parseFloat(coord.lat);
                const lng = parseFloat(coord.lng);

                if (isNaN(lat) || isNaN(lng)) {
                    console.error("Invalid coordinate:", coord);
                    return null;
                }

                return new google.maps.LatLng(lat, lng);
            }).filter(coord => coord !== null); // Filter out any null values

            // Check if the path is valid before creating polygon
            if (path && path.length > 0) {
                const polygon = new google.maps.Polygon({
                    paths: path,
                    strokeColor: '#FF0000',
                    strokeOpacity: 0.8,
                    strokeWeight: 2,
                    fillColor: '#FF0000',
                    fillOpacity: 0.35,
                    map: this.geofenceMap,
                    editable: false,
                    geofenceId: geofence.id,
                });

                polygon.type = google.maps.drawing.OverlayType.POLYGON;
                this.allPolygons.push(polygon);
            } else {
                console.warn("Invalid path for geofence:", geofence);
            }
        }
    }

    getPolygonCoords(polygon: any, geofenceId: string) {
        const path = polygon.getPath();
        const coords = [];

        for (let i = 0; i < path.getLength(); i++) {
            const coord = path.getAt(i);
            coords.push({ lat: coord.lat(), lng: coord.lng() });
        }

        if (!this.selectedLocationGeofence.geofences) {
            this.selectedLocationGeofence.geofences = [];
        }

        this.selectedLocationGeofence.geofences.push({
            id: geofenceId, // Assign the geofence ID
            coordinates: coords,
            type: 'POLYGON',
        });

        console.log('Polygon coordinates:', coords);
        console.log('selected location:', this.selectedLocationGeofence);
    }

    toggleDrawingMode(): void {
        this.isDrawingMode = !this.isDrawingMode;
        this.drawingManager.setDrawingMode(
            this.isDrawingMode ? google.maps.drawing.OverlayType.POLYGON : null
        );
    }

    closeGeofencePopup(): void {
        this.geofencepopupDialogRef.close();
        this.drawingManager.setMap(null);
        this.drawingManager = null;
        this.isDrawingMode = false;
        this.geofenceCoords = [];

        this.allPolygons.forEach(polygon => {
            polygon.setMap(null);
        });
        this.allPolygons = [];
    }

    highlightGeofence(geofenceId: string) {
        this.highlightedGeofence = geofenceId;
        this.setPolygonStyle(geofenceId, '#00FF00', '#00FF00', 2); // Highlight style
    }

    unhighlightGeofence(geofenceId: string) {
        this.highlightedGeofence = null;
        this.setPolygonStyle(geofenceId, '#FF0000', '#FF0000', 1); // Default style
    }

    deleteGeofence(geofenceId: string) {
        const index = this.selectedLocationGeofence.geofences.findIndex(
            g => g.id === geofenceId
        );

        if (index > -1) {
            // Remove geofence data
            this.selectedLocationGeofence.geofences.splice(index, 1);

            // Find and remove the polygon from the map and allPolygons array
            for (let i = 0; i < this.allPolygons.length; i++) {
                if (this.allPolygons[i].geofenceId === geofenceId) {
                    this.allPolygons[i].setMap(null); // Remove from map
                    this.allPolygons.splice(i, 1); // Remove from array
                    break; // Exit loop after finding and removing
                }
            }
        }
    }

    private setPolygonStyle(
        geofenceId: string,
        strokeColor: string,
        fillColor: string,
        zIndex: number
    ) {
        for (let i = 0; i < this.allPolygons.length; i++) {
            if (this.allPolygons[i].geofenceId === geofenceId) {
                this.allPolygons[i].setOptions({
                    strokeColor: strokeColor,
                    fillColor: fillColor,
                    zIndex: zIndex,
                });
                break;
            }
        }
    }

    // Delete Location Functionality
    onDeleteLocation(location: any): void {
        this.locationToDelete = location; // Store the location
        this.deleteConfirmationDialogRef = this.dialog.open(this.deleteConfirmationDialogTemplate, {
            width: '400px',
            disableClose: true,
        });
    }

    closeDeleteConfirmationDialog(): void {
        this.deleteConfirmationDialogRef.close();
        this.locationToDelete = null; // Clear the stored location
    }

    confirmDeleteLocation(): void {
        if (this.locationToDelete) {
            this.showLoader = true;
            this.http.get(`v2/r_location/deleteLocation?_id=${this.locationToDelete._id}`).subscribe(
                (response: any) => {
                    this.showLoader = false;
                    if (response.statusCode === 200) {
                        this.snackbar.openSnackBar(
                            this.translation.instant('Location Deleted Successfully'),
                            ''
                        );
                        this.getInitialLocations(
                            (this.currentPage - 1) * this.itemsPerPage,
                            this.itemsPerPage
                        ); // Refresh the list
                    }
                    this.closeDeleteConfirmationDialog();
                    this.locationToDelete = null;
                },
                (error: any) => {
                    this.showLoader = false;
                    this.snackbar.openSnackBar(
                        this.translation.instant('Error deleting location'),
                        '',
                        'err'
                    );
                    this.closeDeleteConfirmationDialog();
                    this.locationToDelete = null;
                }
            );
        }
    }

    saveGeofence(): void {
        const payload = {
            _id: this.selectedLocationGeofence._id,
            type: this.selectedLocationGeofence.geofences.length > 1 ? 'MULTIPOLYGON' : 'POLYGON',
            coordinates: this.selectedLocationGeofence.geofences.map(geofence =>
                geofence.coordinates.map(coord => [coord.lng, coord.lat])
            )
        }
        this.showLoader = true;
        this.http.post('v2/r_location/updateGeoFence', payload).subscribe(
            (response: any) => {
                this.showLoader = false;
                if (response.statusCode === 200) {
                    this.snackbar.openSnackBar(
                        this.translation.instant('Geofence saved successfully'),
                        '',
                        'success'
                    );
                    this.closeGeofencePopup();
                    this.getInitialLocations(
                        (this.currentPage - 1) * this.itemsPerPage,
                        this.itemsPerPage
                    ); // Refresh the list
                }
            },
            (error: any) => {
                this.showLoader = false;
                this.snackbar.openSnackBar(
                    this.translation.instant('Something went wrong'),
                    '',
                    'err'
                );
            }
        )
    }

    // Manual Selection Mode
    enableManualSelection(): void {
        this.manualSelectionMode = true;
        this.snackbar.openSnackBar('Manual selection enabled. Click on the map to select a location.', '', 'info');
    }

    disableManualSelection(): void {
        this.manualSelectionMode = false;
    }

}
